<app-settings-base
  title="{{'parbleSettings.title' | translate}}"
  description="{{'parbleSettings.text' | translate}}"
  details="{{'parbleSettings.detailsHeader' | translate}}"
  sourceUrl="/setting/parble">
</app-settings-base>
